/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Contact_SentInputs */

const cs_public_site_contact_sent = /** @type {(inputs: Public_Site_Contact_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Děkujeme, vaši zprávu jsme přijali. Brzy se vám ozveme.`)
};

const en_public_site_contact_sent = /** @type {(inputs: Public_Site_Contact_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thank you, we received your message and will get back to you soon.`)
};

/**
* | output |
* | --- |
* | "Thank you, we received your message and will get back to you soon." |
*
* @param {Public_Site_Contact_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_contact_sent = /** @type {((inputs?: Public_Site_Contact_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Contact_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_contact_sent(inputs)
	return cs_public_site_contact_sent(inputs)
});